import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toaster } from 'evergreen-ui';
import uuid from 'uuid';
import api from '../../../services/api';

import DynamicComponent from '../../../components/DynamicComponent';

import { ContentTitleText, ContentTitleBar, ContentTitleButton } from '../../../components/utilities/styledComponents/ContentTitle';
import {
	StyledReportShow,
	GlobalPrintableStyle,
} from './style/StyledReportShow';

import Google from './images/google.svg';
import Facebook from './images/facebook.svg';
import Instagram from './images/instagram.svg';
import { LoaderMain, LoaderPdf } from '../../../components/Loader';

export default class ShowReport extends Component {
	state = {
		collapseGoogle: false,
		collapseFacebook: false,
		collapseFacebookInstagram: false,
		channelMain: null,
		channelGoogle: null,
		channelFacebook: null,
		channelFacebookInstagram: null,
		startDate: '',
		endDate: '',
		shopName: '',
		shopDoc: '',
		preSaleID: '',
		dataReceived: false,
		reportLoading: false,
	};

	componentDidMount() {
		this.loadReports();
	}

	loadReports = async () => {
		const { match } = this.props;

		const reportID = match.params.relatorioId;

		api.get(`reports/${reportID}`)
			.then(response => this.setState({
				channelMain: response.data.channels.find(channel => channel.type === 'main'),
				channelGoogle: response.data.channels.find(channel => channel.type === 'google'),
				channelFacebook: response.data.channels.find(channel => channel.type === 'facebook'),
				channelInstagram: response.data.channels.find(channel => channel.type === 'instagram'),
				channelFacebookInstagram: response.data.channels.find(channel => channel.type === 'facebook_instagram'),
				startDate: response.data.start_date,
				endDate: response.data.end_date,
				shopName: response.data.shop ? response.data.shop.nome : null,
				shopDoc: response.data.shop ? response.data.shop.cnpj : null,
				preSaleID: response.data.pre_sale_id || null,
			}))
			.catch(() => toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				))
			.finally(() => this.setState({ dataReceived: true }));
	};

	toggle = (channel) => {
		switch (channel) {
			case 'isGoogle':
				return this.setState(state => ({ collapseGoogle: !state.collapseGoogle }));
			case 'isFacebook':
				return this.setState(state => ({ collapseFacebook: !state.collapseFacebook }));
			case 'isInstagram':
				return this.setState(state => ({ collapseInstagram: !state.collapseInstagram }));
			case 'isFacebookInstagram':
				return this.setState(state => ({
					collapseFacebookInstagram: !state.collapseFacebookInstagram,
				}));
			default:
				return this.state;
		}
	};

	exportPDF = () => {
		const { match } = this.props;
		const reportID = match.params.relatorioId;
		this.setState({ reportLoading: true });

		const params = {
			responseType: 'arraybuffer',
			headers: {
				Accept: 'application/pdf',
				CockpitLogged: Cookies.get('CockpitLogged'),
				Token: Cookies.get('Token'),
				frontURL: process.env.REACT_APP_URL,
			},
		};

		axios.get(`${process.env.REACT_APP_PUPPETEER_URL}/export-pdf/relatorio/${reportID}`, params)
		.then((response) => {
			// handle success
			const blob = new Blob([response.data], { type: 'application/pdf' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = `relatorio-${reportID}.pdf`;
			link.click();
			this.setState({ reportLoading: false });
		})
		.catch(() => {
			this.setState({ reportLoading: false });
			return toaster.danger(
				'Ops! Ocorreu um erro ao gerar seu pdf, tente novamente mais tarde.',
			);
		});
	}

	render() {
		const {
			channelMain,
			channelGoogle,
			collapseGoogle,
			channelFacebook,
			collapseFacebook,
			channelFacebookInstagram,
			collapseFacebookInstagram,
			channelInstagram,
			collapseInstagram,
			dataReceived,
			reportLoading,
			startDate,
			endDate,
			shopName,
			shopDoc,
			preSaleID,
		} = this.state;

		return (
			<Fragment>
				<GlobalPrintableStyle />
				<ContentTitleBar>
					<ContentTitleText>Gearbox - Relatórios</ContentTitleText>
					{
						dataReceived && (
							<ContentTitleButton onClick={() => this.exportPDF()} disabled={reportLoading}>
								{ reportLoading ? (<LoaderPdf />) : 'Exportar relatório' }
							</ContentTitleButton>
						)
					}
				</ContentTitleBar>

				<StyledReportShow className={`container-gearbox ${!dataReceived ? 'loading-page' : null}`}>
					<Link to="/relatorios" className="link-back">{'< Voltar para relatórios de campanha'}</Link>
					<div id="pdf_content">
						<div id="report_header">
							<h1>Relatório da campanha: {shopName} | {shopDoc} | {preSaleID}</h1>
							<h2>{startDate} até {endDate}</h2>
							<hr />
						</div>
						{
						dataReceived ? (
							<Fragment>
								{channelMain ? channelMain.widgets.map(widget => (
									widget.variables ? (
										<DynamicComponent
											tag={widget.variables.component}
											data={widget}
											key={uuid.v4()}
										/>
									) : null
								)) : ''}

								{channelGoogle ? (
									<section className="channel">
										<div className={`google dropdown dropdown-opened ${collapseGoogle ? 'd-none' : 'd-block'}`}>
											<header>
												<img src={Google} alt="Google ADS" width={136} height={34} />
												<i className="fa fa-angle-down btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isGoogle')} />
											</header>
										</div>

										<div className={`google dropdown dropdown-closed pb-4 ${collapseGoogle ? 'd-block' : 'd-none'}`}>
											<i className="fa fa-angle-up btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isGoogle')} />

											<main>
												<header>
													<img src={Google} alt="Logo do Google" width={136} height={34} />
												</header>

												{
													channelGoogle ? channelGoogle.widgets.map((widget, indice) => (
														widget.variables ? (
															<div className="no-break">
																<DynamicComponent
																	tag={widget.variables.component}
																	channel="google"
																	data={widget}
																	isLast={(channelGoogle.widgets.length - 1 === indice)}
																	key={uuid.v4()}
																/>
															</div>
														) : null
													)) : ''
												}
											</main>
										</div>
									</section>
								) : null}

								{channelFacebook ? (
									<section className="channel">
										<div className={`facebook dropdown dropdown-opened ${collapseFacebook ? 'd-none' : 'd-block'}`}>
											<header>
												<img src={Facebook} alt="Facebook" width={136} height={34} />
												<i className="fa fa-angle-down btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isFacebook')} />
											</header>
										</div>

										<div className={`facebook dropdown dropdown-closed pb-4 ${collapseFacebook ? 'd-block' : 'd-none'}`}>
											<i className="fa fa-angle-up btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isFacebook')} />

											<main>
												<header>
													<img src={Facebook} alt="Logo do Facebook" width={136} height={34} />
												</header>

												{
													channelFacebook ? channelFacebook.widgets.map((widget, indice) => (
														widget.variables ? (
															<div className="no-break">
																<DynamicComponent
																	tag={widget.variables.component}
																	channel="facebook"
																	data={widget}
																	isLast={(channelFacebook.widgets.length - 1 === indice)}
																	key={uuid.v4()}
																/>
															</div>
														) : null
													)) : ''
												}
											</main>
										</div>
									</section>
								) : null}

								{channelInstagram ? (
									<section className="channel">
										<div className={`instagram dropdown dropdown-opened ${collapseInstagram ? 'd-none' : 'd-block'}`}>
											<header>
												<img src={Instagram} alt="Instagram" width={136} height={34} />
												<i className="fa fa-angle-down btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isInstagram')} />
											</header>
										</div>

										<div className={`instagram dropdown dropdown-closed pb-4 ${collapseInstagram ? 'd-block' : 'd-none'}`}>
											<i className="fa fa-angle-up btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isInstagram')} />

											<main>
												<header>
													<img src={Instagram} alt="Instagram" width={136} height={34} />
												</header>

												{
													channelInstagram ? channelInstagram.widgets.map((widget, indice) => (
														widget.variables ? (
															<div className="no-break">
																<DynamicComponent
																	tag={widget.variables.component}
																	channel="instagram"
																	data={widget}
																	isLast={(channelInstagram.widgets.length - 1 === indice)}
																	key={uuid.v4()}
																/>
															</div>
														) : null
													)) : ''
												}
											</main>
										</div>
									</section>
								) : null}

								{channelFacebookInstagram ? (
									<section className="channel">
										<div className={`facebook dropdown dropdown-opened ${collapseFacebookInstagram ? 'd-none' : 'd-block'}`}>
											<header className="justify-content-start">
												<img src={Facebook} alt="Facebook" width={136} height={34} />
												<span className="text-header">&</span>
												<img src={Instagram} alt="Facebook" width={136} height={34} />
												<i className="fa fa-angle-down btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isFacebookInstagram')} />
											</header>
										</div>

										<div className={`facebook dropdown dropdown-closed pb-4 ${collapseFacebookInstagram ? 'd-block' : 'd-none'}`}>
											<i className="fa fa-angle-up btn-dropdown" aria-hidden="true" onClick={this.toggle.bind(this, 'isFacebookInstagram')} />

											<main>
												<header className="justify-content-start">
													<img src={Facebook} alt="Facebook" width={136} height={34} />
													<span className="text-header">&</span>
													<img src={Instagram} alt="Facebook" width={136} height={34} />
												</header>

												{
													channelFacebookInstagram ? channelFacebookInstagram.widgets.map(
														(widget, indice) => (
															widget.variables ? (
																<div className="no-break">
																	<DynamicComponent
																		tag={widget.variables.component}
																		channel="facebook_instagram"
																		data={widget}
																		isLast={(
																			channelFacebookInstagram.widgets.length - 1 === indice
																		)}
																		key={uuid.v4()}
																	/>
																</div>
															) : null
														),
													) : ''
												}
											</main>
										</div>
									</section>
								) : null}
							</Fragment>
						) : <LoaderMain />
					}
					</div>
				</StyledReportShow>
			</Fragment>

		);
	}
}
